export enum RequestNudgeType {
    CONVERSATION_START = 'conversation_start',
    SESSION_START = 'session_start',
    NEW_PAGE_VISIT = 'new_page_visit',
}